import { render, staticRenderFns } from "./formUploadFile.vue?vue&type=template&id=cf4ce4d0&scoped=true"
import script from "./formUploadFile.vue?vue&type=script&lang=js"
export * from "./formUploadFile.vue?vue&type=script&lang=js"
import style0 from "./formUploadFile.vue?vue&type=style&index=0&id=cf4ce4d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4ce4d0",
  null
  
)

export default component.exports